import { render, staticRenderFns } from "./PageHome.vue?vue&type=template&id=146cb6d2&scoped=true"
import script from "./PageHome.vue?vue&type=script&lang=js"
export * from "./PageHome.vue?vue&type=script&lang=js"
import style0 from "./PageHome.vue?vue&type=style&index=0&id=146cb6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146cb6d2",
  null
  
)

export default component.exports